// import ChangeLog from './changelog.json'


//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'
import { Data as OtherContent } from '../listenKey/index'


import { Data as AccountContent } from './api/account/index'
import { Data as TradeOrderContent } from './api/trade/index'
import { Data as MarketContent } from './api/market/index'
import { Data as BasicContent } from './api/basic/index'
import Introduce from './1_introduce.json'
import Description from './2_description.json'
import { List as SocketContent } from './websocket/index'


let aaa = JSON.stringify(OtherContent).replaceAll("/market/","/swap-market?")
 aaa = aaa.replaceAll("/market","/swap-market")
 aaa = aaa.replaceAll("open-api-ws.bingx.com","open-api-swap.bingx.com")
 aaa = aaa.replaceAll("/swap-market?<listenKey>","/swap-market?listenKey=")
 aaa = aaa.replaceAll("wss://open-api-swap.bingx.com/swap-market?listenKey=","wss://open-api-swap.bingx.com/swap-market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
// import Socket from './websocket/websocket.json'
const ROOT_MODULE = "zh-tw/swapV2"

import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "常見問題",
  "content": QandAContent
}
export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket 文檔",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "變更日誌",
  "content": ChangeLogContent
}
const TradeOrder = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trade-api.html`,
  "name": "交易接口",
  "content": TradeOrderContent
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "簽名認證",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "基礎信息",
  "content": BasicContent
}
const Account = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/account-api.html`,
  "name": "賬戶接口",
  "content": AccountContent
}
const Other = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/listen-key.html`,
  "name": "Listen Key",
  "content": JSON.parse(aaa)
}
const Market = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/market-api.html`,
  "name": "行情數據",
  "content": MarketContent
}

export const swapV2Config = [
  Introduce,
  ChangeLog,
  QandA,
  Description,
  Authentication,
  Basic,
  Market,
  Account,
  TradeOrder,
  Socket,
]


// WEBPACK FOOTER //
// ./src/config/zh-tw/swapV2/index.js